import { useHistory, useLocation } from 'react-router-dom';

/**
 * Navigate to a route in a modal manner.
 * This pushes the current location to the history background
 */
export default function useModalLink(): (route: string) => void {
  const history = useHistory();
  const location = useLocation();

  return (route: string) => history.push(route, { background: location });
}
